// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-box {
  background: #181818;
  padding: 40px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  color: #fff;
  text-align: center;
  width: 500px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}

._tadashi_svelte_notification {
  grid-gap: 0px !important;
}

.animate,
.animate-left,
.animate-right {
  opacity: 0;
  filter: blur(5px);
  transform: translateX(-20px);
  transition: all 0.1s ease-in-out;
}

.animate-left {
  transform: translateX(-20px);
}

.animate-right {
  transform: translateX(20px);
}

.scroll-animation {
  opacity: 1;
  filter: blur(0px);
  transform: translateX(0);
}

.delay-0 {
  transition-delay: 0.1s;
}

.delay-1 {
  transition-delay: 0.15s;
}

.delay-2 {
  transition-delay: 0.2s;
}

.delay-3 {
  transition-delay: 0.25s;
}

.delay-4 {
  transition-delay: 0.3s;
}

.delay-5 {
  transition-delay: 0.35s;
}

.delay-6 {
  transition-delay: 0.4s;
}

.delay-7 {
  transition-delay: 0.45s;
}

.delay-8 {
  transition-delay: 0.5s;
}

.delay-9 {
  transition-delay: 0.55s;
}

.delay-10 {
  transition-delay: 0.6s;
}

[data-tooltip] {
  position: relative;
  z-index: 5;
  display: block;
}

[data-tooltip]:before,
[data-tooltip]:after {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: 0.2s ease-out;
  transform: translate(-50%, 5px);
}

[data-tooltip]:before {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-bottom: 5px;
  padding: 7px;
  width: 100%;
  min-width: 70px;
  max-width: 250px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  background-color: #000;
  background-color: hsla(0, 0%, 20%, 0.9);
  color: #fff;
  content: attr(data-tooltip);
  text-align: center;
  font-size: 14px;
  line-height: 1.2;
  transition: 0.2s ease-out;
}

[data-tooltip]:after {
  position: absolute;
  bottom: 100%;
  left: 50%;
  width: 0;
  border-top: 5px solid #000;
  border-top: 5px solid hsla(0, 0%, 20%, 0.9);
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  content: " ";
  font-size: 0;
  line-height: 0;
}

[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  visibility: visible;
  opacity: 1;
  transform: translate(-50%, 0);
}

[data-tooltip=false]:hover:before,
[data-tooltip=false]:hover:after {
  visibility: hidden;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;AACJ;;AAGA;EACI,wBAAA;AAAJ;;AAKA;;;EAGI,UAAA;EACA,iBAAA;EACA,4BAAA;EACA,gCAAA;AAFJ;;AAKA;EACI,4BAAA;AAFJ;;AAKA;EACI,2BAAA;AAFJ;;AAKA;EACI,UAAA;EACA,iBAAA;EACA,wBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,UAAA;EACA,cAAA;AAFJ;;AAKA;;EAEI,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,+BAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,0BAAA;EACA,2CAAA;EACA,mCAAA;EACA,kCAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAFJ;;AAKA;;EAEI,mBAAA;EACA,UAAA;EACA,6BAAA;AAFJ;;AAKA;;EAEI,kBAAA;EACA,UAAA;AAFJ","sourcesContent":[".modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.85);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.modal-box {\n    background: #181818;\n    padding: 40px;\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n    color: #fff;\n    text-align: center;\n    width: 500px;\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);\n}\n\n\n._tadashi_svelte_notification {\n    grid-gap: 0px !important;\n}\n\n//scroll animate \n\n.animate,\n.animate-left,\n.animate-right {\n    opacity: 0;\n    filter: blur(5px);\n    transform: translateX(-20px);\n    transition: all 0.1s ease-in-out;\n}\n\n.animate-left {\n    transform: translateX(-20px);\n}\n\n.animate-right {\n    transform: translateX(20px);\n}\n\n.scroll-animation {\n    opacity: 1;\n    filter: blur(0px);\n    transform: translateX(0);\n}\n\n.delay-0 {\n    transition-delay: 0.1s;\n}\n\n.delay-1 {\n    transition-delay: 0.15s;\n}\n\n.delay-2 {\n    transition-delay: 0.2s;\n}\n\n.delay-3 {\n    transition-delay: 0.25s;\n}\n\n.delay-4 {\n    transition-delay: 0.3s;\n}\n\n.delay-5 {\n    transition-delay: 0.35s;\n}\n\n.delay-6 {\n    transition-delay: 0.4s;\n}\n\n.delay-7 {\n    transition-delay: 0.45s;\n}\n\n.delay-8 {\n    transition-delay: 0.5s;\n}\n\n.delay-9 {\n    transition-delay: 0.55s;\n}\n\n.delay-10 {\n    transition-delay: 0.6s;\n}\n\n[data-tooltip] {\n    position: relative;\n    z-index: 5;\n    display: block;\n}\n\n[data-tooltip]:before,\n[data-tooltip]:after {\n    visibility: hidden;\n    opacity: 0;\n    pointer-events: none;\n    transition: .2s ease-out;\n    transform: translate(-50%, 5px)\n}\n\n[data-tooltip]:before {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    margin-bottom: 5px;\n    padding: 7px;\n    width: 100%;\n    min-width: 70px;\n    max-width: 250px;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    background-color: #000;\n    background-color: hsla(0, 0%, 20%, 0.9);\n    color: #fff;\n    content: attr(data-tooltip);\n    text-align: center;\n    font-size: 14px;\n    line-height: 1.2;\n    transition: .2s ease-out\n}\n\n[data-tooltip]:after {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    width: 0;\n    border-top: 5px solid #000;\n    border-top: 5px solid hsla(0, 0%, 20%, 0.9);\n    border-right: 5px solid transparent;\n    border-left: 5px solid transparent;\n    content: \" \";\n    font-size: 0;\n    line-height: 0;\n}\n\n[data-tooltip]:hover:before,\n[data-tooltip]:hover:after {\n    visibility: visible;\n    opacity: 1;\n    transform: translate(-50%, 0)\n}\n\n[data-tooltip=false]:hover:before,\n[data-tooltip=false]:hover:after {\n    visibility: hidden;\n    opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
